/**
 * The editable Business Profile: the Owner's working copy of the latest
 * draft, loaded once per draft artifact, and the correction and rejection
 * notes beside it.
 */

import { useEffect, useState } from 'react';

import type { BusinessProfileDraft } from '@mouja/domain/analysis';

import type { AsyncState } from '../common.js';
import type { AnalysisRunDetail } from './analysis-run-detail.js';

export function useBusinessProfileDraft(state: AsyncState<AnalysisRunDetail>) {
  const [profile, setProfile] = useState<BusinessProfileDraft | null>(null);
  const [loadedDraftId, setLoadedDraftId] = useState<string | null>(null);
  const [correctionReason, setCorrectionReason] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');

  useEffect(() => {
    if (state.status !== 'ready') return;
    const draft = state.value.day2.draft;
    if (draft !== null && draft.id !== loadedDraftId) {
      setProfile(structuredClone(draft.payload));
      setLoadedDraftId(draft.id);
    }
  }, [loadedDraftId, state]);

  return {
    profile,
    setProfile,
    correctionReason,
    setCorrectionReason,
    rejectionReason,
    setRejectionReason,
  };
}
